import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managecustomer',
  templateUrl: './managecustomer.component.html',
  styleUrls: ['./managecustomer.component.scss']
})
export class ManagecustomerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
